import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { API_BASE_URL } from '../constants/consts';
import { authFirewallQueryKeys } from '../constants/queryKeys';
import { apiGet } from '../../../../api/queries/apiGet';

const END_POINT = '/domains';

const fetchDomains = async (): Promise<string[]> => {
    const data = await apiGet<string[]>(`${API_BASE_URL}${END_POINT}`);
    return data;
};

export const useGetDomains = (): UseQueryResult<string[]> => {
    return useQuery({
        queryKey: authFirewallQueryKeys.domains(),
        queryFn: () => fetchDomains()
    });
};
